export const ORBIT_PLANNER_CAMERA_DESCRIPTION = {
    name: 'orbit-planner-camera-description',
    is_enabled: true,
    initiate_tabs: [
        {
            tag: 'Cameras',
            setup: (tab, camera) => {
                const container = tab.get_container('🎥 ' + camera.name, { is_collapsed: !camera.debug_geometry });
                container.custom.watch('checkbox', {
                    name: 'Show Debug Gizmo',
                    get: () => !!camera.debug_geometry,
                    set: (v) => {
                        if (v) {
                            camera.create_debug_geometry();
                        }
                        else {
                            camera.remove_debug_geometry();
                        }
                    }
                });
                if (camera.debug_geometry) {
                    const gizmo_config = container.container('Gizmo Config');
                    gizmo_config.watch(camera.debug_geometry, 'always_update');
                    gizmo_config.watch(camera.debug_geometry.frustum, 'is_enabled', { name: 'Show Frustum' });
                    gizmo_config.watch(camera.debug_geometry.camera, 'show_orbit_limits');
                    gizmo_config.watch(camera.debug_geometry.camera, 'show_pan_limits');
                    gizmo_config.watch(camera.debug_geometry.camera, 'show_collision_radius');
                    gizmo_config.watch(camera.debug_geometry.camera, 'show_target');
                }
                container.watch(camera, 'offset');
                container.watch(camera, 'target');
                const rotation = container.container('rotation');
                rotation.watch(camera, 'yaw_radians', { name: 'yaw' });
                rotation.watch(camera, 'pitch_radians', { name: 'pitch' });
                const projection = container.container('Projection');
                projection.watch(camera.projection, 'aspect_ratio', { is_readonly: true });
                projection.watch(camera.projection, 'near', { is_readonly: true });
                projection.watch(camera.projection, 'far', { is_readonly: true });
                const fov = projection.container('Field of View', { is_collapsed: true });
                fov.watch(camera.projection, 'field_of_view');
                fov.watch(camera.projection, 'horizontal_fov', { is_readonly: true });
                fov.watch(camera.projection, 'vertical_fov', { is_readonly: true });
                fov.watch(camera.projection, 'field_of_view_direction', { is_readonly: true });
                const limits = container.container('limits', { is_collapsed: true });
                // Orbit Limits Setter
                const orbit_limits_value = {
                    up: Math.PI / 4, down: Math.PI / 4, left: Math.PI / 4, right: Math.PI / 4
                };
                const orbit_limits = limits.container('orbit', { is_collapsed: true });
                Object.keys(orbit_limits_value).forEach((key) => orbit_limits.watch(orbit_limits_value, key));
                orbit_limits.button('Set', { on_click: () => camera.set_orbit_limits(orbit_limits_value) });
                // Pan Limits Setter
                const pan_limits_value = {
                    min: { x: -1, y: 0, z: -1 },
                    max: { x: 1, y: 2, z: 1 }
                };
                const pan_limits = limits.container('pan', { is_collapsed: true });
                Object.keys(pan_limits_value).forEach((key) => pan_limits.watch(pan_limits_value, key));
                pan_limits.button('Set', { on_click: () => camera.set_pan_limits(pan_limits_value) });
                limits.button('Clear Limits', { on_click: () => camera['clear_all_limits']() });
            },
            dependencies: (camera) => {
                return [() => !!camera.debug_geometry]; // Rerender if debug geometry value changes.
            }
        }
    ]
};
//# sourceMappingURL=OrbitPlannerCameraDescription.js.map